<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { Default } from "../../../../utils/Constant/Constant";
  import { TimePicker } from "svelte-time-picker";
  let time: any;
  let myCallback = (event: any) => {
    time = event.detail;
  };
</script>

<Col lg="6">
  <Card headerTitle="{Default}:">
    <div slot="contentbody">
      <form class="theme-form">
        <div>
          <TimePicker on:change={myCallback} bind:value={time} />
        </div>
      </form>
    </div>
  </Card>
</Col>
